import { api } from './index';
import { Methods } from './interfaces';
import { Course } from '@/types/course';

const { POST, GET } = Methods;

const getAllCourses = () =>
  api<void, Course[]>({
    method: POST,
    route: '/course/withTeacher/getAll',
  });

const getCourse = (courseId: string) =>
  api<void, any>({
    method: POST,
    route: `/course/get/${courseId}`,
  });

const findLesson = (lessonId: string) =>
  api<void, any>({
    method: GET,
    route: `/course/find-lesson/${lessonId}`,
  });

export const courseApi = { getAllCourses, getCourse, findLesson };
